module.exports = __webpack_public_path__ + "5bf4711f3516988392be07d34eef68b7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/img16-9.jpg
 ** module id = 512
 ** module chunks = 1
 **/